import {SocketRxMessage, SocketRxMessageData, SocketTxMessage} from "proto_socket_typescript";
import {authentication, lesson, lessons, recording, recordings, sfiles, socket_api, uploader} from "./compiled";

export namespace proto {

export class TxLogin extends SocketTxMessage<authentication.Login> {
    static type: string = 'login';
    proto: authentication.Login;
    protoClass = authentication.Login;
    

    constructor(proto: authentication.Login) {
        super(TxLogin.type, true);
        this.proto = proto;
    }

    static create(properties: authentication.ILogin = {}) {
        return new TxLogin(authentication.Login.create(properties));
    }
}


export class RxLoginError extends SocketRxMessage<authentication.LoginError> {
    static type: string = 'login-error';
    proto = authentication.LoginError.create({});
    protoClass = authentication.LoginError;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxLoginError.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxLoginError(message);
    };
}


export class RxLoginToken extends SocketRxMessage<authentication.LoginToken> {
    static type: string = 'login-token';
    proto = authentication.LoginToken.create({});
    protoClass = authentication.LoginToken;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxLoginToken.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxLoginToken(message);
    };
}


export class TxRefreshToken extends SocketTxMessage<authentication.RefreshToken> {
    static type: string = 'refresh-token';
    proto: authentication.RefreshToken;
    protoClass = authentication.RefreshToken;
    

    constructor(proto: authentication.RefreshToken) {
        super(TxRefreshToken.type, true);
        this.proto = proto;
    }

    static create(properties: authentication.IRefreshToken = {}) {
        return new TxRefreshToken(authentication.RefreshToken.create(properties));
    }
}


export class RxRefreshTokenInvalid extends SocketRxMessage<authentication.RefreshTokenInvalid> {
    static type: string = 'refresh-token-invalid';
    proto = authentication.RefreshTokenInvalid.create({});
    protoClass = authentication.RefreshTokenInvalid;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxRefreshTokenInvalid.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxRefreshTokenInvalid(message);
    };
}


export class RxTokenInvalid extends SocketRxMessage<authentication.TokenInvalid> {
    static type: string = 'token-invalid';
    proto = authentication.TokenInvalid.create({});
    protoClass = authentication.TokenInvalid;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxTokenInvalid.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxTokenInvalid(message);
    };
}


export class TxVerifyToken extends SocketTxMessage<authentication.VerifyToken> {
    static type: string = 'verify-token';
    proto: authentication.VerifyToken;
    protoClass = authentication.VerifyToken;
    

    constructor(proto: authentication.VerifyToken) {
        super(TxVerifyToken.type, true);
        this.proto = proto;
    }

    static create(properties: authentication.IVerifyToken = {}) {
        return new TxVerifyToken(authentication.VerifyToken.create(properties));
    }
}


export class TxGetLesson extends SocketTxMessage<lesson.GetLesson> {
    static type: string = 'get-lesson';
    proto: lesson.GetLesson;
    protoClass = lesson.GetLesson;
    

    constructor(proto: lesson.GetLesson) {
        super(TxGetLesson.type, true);
        this.proto = proto;
    }

    static create(properties: lesson.IGetLesson = {}) {
        return new TxGetLesson(lesson.GetLesson.create(properties));
    }
}


export class RxGetLessonResponse extends SocketRxMessage<lesson.GetLessonResponse> {
    static type: string = 'get-lesson-response';
    proto = lesson.GetLessonResponse.create({});
    protoClass = lesson.GetLessonResponse;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxGetLessonResponse.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxGetLessonResponse(message);
    };
}


export class TxAddLessonAsset extends SocketTxMessage<lessons.AddLessonAsset> {
    static type: string = 'add-lesson-asset';
    proto: lessons.AddLessonAsset;
    protoClass = lessons.AddLessonAsset;
    

    constructor(proto: lessons.AddLessonAsset) {
        super(TxAddLessonAsset.type, true);
        this.proto = proto;
    }

    static create(properties: lessons.IAddLessonAsset = {}) {
        return new TxAddLessonAsset(lessons.AddLessonAsset.create(properties));
    }
}


export class TxCreateChapter extends SocketTxMessage<lessons.CreateChapter> {
    static type: string = 'create-chapter';
    proto: lessons.CreateChapter;
    protoClass = lessons.CreateChapter;
    

    constructor(proto: lessons.CreateChapter) {
        super(TxCreateChapter.type, true);
        this.proto = proto;
    }

    static create(properties: lessons.ICreateChapter = {}) {
        return new TxCreateChapter(lessons.CreateChapter.create(properties));
    }
}


export class RxCreateChapterResponse extends SocketRxMessage<lessons.CreateChapterResponse> {
    static type: string = 'create-chapter-response';
    proto = lessons.CreateChapterResponse.create({});
    protoClass = lessons.CreateChapterResponse;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxCreateChapterResponse.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxCreateChapterResponse(message);
    };
}


export class TxCreateContentBlock extends SocketTxMessage<lessons.CreateContentBlock> {
    static type: string = 'create-content-block';
    proto: lessons.CreateContentBlock;
    protoClass = lessons.CreateContentBlock;
    

    constructor(proto: lessons.CreateContentBlock) {
        super(TxCreateContentBlock.type, true);
        this.proto = proto;
    }

    static create(properties: lessons.ICreateContentBlock = {}) {
        return new TxCreateContentBlock(lessons.CreateContentBlock.create(properties));
    }
}


export class RxCreateContentBlockResponse extends SocketRxMessage<lessons.CreateContentBlockResponse> {
    static type: string = 'create-content-block-response';
    proto = lessons.CreateContentBlockResponse.create({});
    protoClass = lessons.CreateContentBlockResponse;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxCreateContentBlockResponse.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxCreateContentBlockResponse(message);
    };
}


export class TxCreateLesson extends SocketTxMessage<lessons.CreateLesson> {
    static type: string = 'create-lesson';
    proto: lessons.CreateLesson;
    protoClass = lessons.CreateLesson;
    

    constructor(proto: lessons.CreateLesson) {
        super(TxCreateLesson.type, true);
        this.proto = proto;
    }

    static create(properties: lessons.ICreateLesson = {}) {
        return new TxCreateLesson(lessons.CreateLesson.create(properties));
    }
}


export class RxCreateLessonResponse extends SocketRxMessage<lessons.CreateLessonResponse> {
    static type: string = 'create-lesson-response';
    proto = lessons.CreateLessonResponse.create({});
    protoClass = lessons.CreateLessonResponse;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxCreateLessonResponse.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxCreateLessonResponse(message);
    };
}


export class TxDeleteChapter extends SocketTxMessage<lessons.DeleteChapter> {
    static type: string = 'delete-chapter';
    proto: lessons.DeleteChapter;
    protoClass = lessons.DeleteChapter;
    

    constructor(proto: lessons.DeleteChapter) {
        super(TxDeleteChapter.type, true);
        this.proto = proto;
    }

    static create(properties: lessons.IDeleteChapter = {}) {
        return new TxDeleteChapter(lessons.DeleteChapter.create(properties));
    }
}


export class TxDeleteContentBlock extends SocketTxMessage<lessons.DeleteContentBlock> {
    static type: string = 'delete-content-block';
    proto: lessons.DeleteContentBlock;
    protoClass = lessons.DeleteContentBlock;
    

    constructor(proto: lessons.DeleteContentBlock) {
        super(TxDeleteContentBlock.type, true);
        this.proto = proto;
    }

    static create(properties: lessons.IDeleteContentBlock = {}) {
        return new TxDeleteContentBlock(lessons.DeleteContentBlock.create(properties));
    }
}


export class TxDeleteLesson extends SocketTxMessage<lessons.DeleteLesson> {
    static type: string = 'delete-lesson';
    proto: lessons.DeleteLesson;
    protoClass = lessons.DeleteLesson;
    

    constructor(proto: lessons.DeleteLesson) {
        super(TxDeleteLesson.type, true);
        this.proto = proto;
    }

    static create(properties: lessons.IDeleteLesson = {}) {
        return new TxDeleteLesson(lessons.DeleteLesson.create(properties));
    }
}


export class TxListLessons extends SocketTxMessage<lessons.ListLessons> {
    static type: string = 'list-lessons';
    proto: lessons.ListLessons;
    protoClass = lessons.ListLessons;
    

    constructor(proto: lessons.ListLessons) {
        super(TxListLessons.type, true);
        this.proto = proto;
    }

    static create(properties: lessons.IListLessons = {}) {
        return new TxListLessons(lessons.ListLessons.create(properties));
    }
}


export class RxListLessonsResponse extends SocketRxMessage<lessons.ListLessonsResponse> {
    static type: string = 'list-lessons-response';
    proto = lessons.ListLessonsResponse.create({});
    protoClass = lessons.ListLessonsResponse;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxListLessonsResponse.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxListLessonsResponse(message);
    };
}


export class TxListPublishedAnnotations extends SocketTxMessage<lessons.ListPublishedAnnotations> {
    static type: string = 'list-published-annotations';
    proto: lessons.ListPublishedAnnotations;
    protoClass = lessons.ListPublishedAnnotations;
    

    constructor(proto: lessons.ListPublishedAnnotations) {
        super(TxListPublishedAnnotations.type, true);
        this.proto = proto;
    }

    static create(properties: lessons.IListPublishedAnnotations = {}) {
        return new TxListPublishedAnnotations(lessons.ListPublishedAnnotations.create(properties));
    }
}


export class RxListPublishedAnnotationsResponse extends SocketRxMessage<lessons.ListPublishedAnnotationsResponse> {
    static type: string = 'list-published-annotations-response';
    proto = lessons.ListPublishedAnnotationsResponse.create({});
    protoClass = lessons.ListPublishedAnnotationsResponse;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxListPublishedAnnotationsResponse.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxListPublishedAnnotationsResponse(message);
    };
}


export class TxUpdateChapter extends SocketTxMessage<lessons.UpdateChapter> {
    static type: string = 'update-chapter';
    proto: lessons.UpdateChapter;
    protoClass = lessons.UpdateChapter;
    

    constructor(proto: lessons.UpdateChapter) {
        super(TxUpdateChapter.type, true);
        this.proto = proto;
    }

    static create(properties: lessons.IUpdateChapter = {}) {
        return new TxUpdateChapter(lessons.UpdateChapter.create(properties));
    }
}


export class RxUpdateChapterResponse extends SocketRxMessage<lessons.UpdateChapterResponse> {
    static type: string = 'update-chapter-response';
    proto = lessons.UpdateChapterResponse.create({});
    protoClass = lessons.UpdateChapterResponse;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxUpdateChapterResponse.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxUpdateChapterResponse(message);
    };
}


export class TxUpdateContentBlock extends SocketTxMessage<lessons.UpdateContentBlock> {
    static type: string = 'update-content-block';
    proto: lessons.UpdateContentBlock;
    protoClass = lessons.UpdateContentBlock;
    

    constructor(proto: lessons.UpdateContentBlock) {
        super(TxUpdateContentBlock.type, true);
        this.proto = proto;
    }

    static create(properties: lessons.IUpdateContentBlock = {}) {
        return new TxUpdateContentBlock(lessons.UpdateContentBlock.create(properties));
    }
}


export class RxUpdateContentBlockResponse extends SocketRxMessage<lessons.UpdateContentBlockResponse> {
    static type: string = 'update-content-block-response';
    proto = lessons.UpdateContentBlockResponse.create({});
    protoClass = lessons.UpdateContentBlockResponse;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxUpdateContentBlockResponse.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxUpdateContentBlockResponse(message);
    };
}


export class TxUpdateLesson extends SocketTxMessage<lessons.UpdateLesson> {
    static type: string = 'update-lesson';
    proto: lessons.UpdateLesson;
    protoClass = lessons.UpdateLesson;
    

    constructor(proto: lessons.UpdateLesson) {
        super(TxUpdateLesson.type, true);
        this.proto = proto;
    }

    static create(properties: lessons.IUpdateLesson = {}) {
        return new TxUpdateLesson(lessons.UpdateLesson.create(properties));
    }
}


export class TxCreateRecording extends SocketTxMessage<recording.CreateRecording> {
    static type: string = 'create-recording';
    proto: recording.CreateRecording;
    protoClass = recording.CreateRecording;
    

    constructor(proto: recording.CreateRecording) {
        super(TxCreateRecording.type, true);
        this.proto = proto;
    }

    static create(properties: recording.ICreateRecording = {}) {
        return new TxCreateRecording(recording.CreateRecording.create(properties));
    }
}


export class RxCreateRecordingResponse extends SocketRxMessage<recording.CreateRecordingResponse> {
    static type: string = 'create-recording-response';
    proto = recording.CreateRecordingResponse.create({});
    protoClass = recording.CreateRecordingResponse;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxCreateRecordingResponse.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxCreateRecordingResponse(message);
    };
}


export class TxDeleteRecording extends SocketTxMessage<recording.DeleteRecording> {
    static type: string = 'delete-recording';
    proto: recording.DeleteRecording;
    protoClass = recording.DeleteRecording;
    

    constructor(proto: recording.DeleteRecording) {
        super(TxDeleteRecording.type, true);
        this.proto = proto;
    }

    static create(properties: recording.IDeleteRecording = {}) {
        return new TxDeleteRecording(recording.DeleteRecording.create(properties));
    }
}


export class TxDeleteRecordingAnnotation extends SocketTxMessage<recording.DeleteRecordingAnnotation> {
    static type: string = 'delete-recording-annotation';
    proto: recording.DeleteRecordingAnnotation;
    protoClass = recording.DeleteRecordingAnnotation;
    

    constructor(proto: recording.DeleteRecordingAnnotation) {
        super(TxDeleteRecordingAnnotation.type, true);
        this.proto = proto;
    }

    static create(properties: recording.IDeleteRecordingAnnotation = {}) {
        return new TxDeleteRecordingAnnotation(recording.DeleteRecordingAnnotation.create(properties));
    }
}


export class TxGetRecording extends SocketTxMessage<recording.GetRecording> {
    static type: string = 'get-recording';
    proto: recording.GetRecording;
    protoClass = recording.GetRecording;
    

    constructor(proto: recording.GetRecording) {
        super(TxGetRecording.type, true);
        this.proto = proto;
    }

    static create(properties: recording.IGetRecording = {}) {
        return new TxGetRecording(recording.GetRecording.create(properties));
    }
}


export class RxGetRecordingResponse extends SocketRxMessage<recording.GetRecordingResponse> {
    static type: string = 'get-recording-response';
    proto = recording.GetRecordingResponse.create({});
    protoClass = recording.GetRecordingResponse;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxGetRecordingResponse.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxGetRecordingResponse(message);
    };
}


export class TxSaveRecordingAnnotation extends SocketTxMessage<recording.SaveRecordingAnnotation> {
    static type: string = 'save-recording-annotation';
    proto: recording.SaveRecordingAnnotation;
    protoClass = recording.SaveRecordingAnnotation;
    

    constructor(proto: recording.SaveRecordingAnnotation) {
        super(TxSaveRecordingAnnotation.type, true);
        this.proto = proto;
    }

    static create(properties: recording.ISaveRecordingAnnotation = {}) {
        return new TxSaveRecordingAnnotation(recording.SaveRecordingAnnotation.create(properties));
    }
}


export class RxSaveRecordingAnnotationResponse extends SocketRxMessage<recording.SaveRecordingAnnotationResponse> {
    static type: string = 'save-recording-annotation-response';
    proto = recording.SaveRecordingAnnotationResponse.create({});
    protoClass = recording.SaveRecordingAnnotationResponse;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxSaveRecordingAnnotationResponse.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxSaveRecordingAnnotationResponse(message);
    };
}


export class TxUpdateRecording extends SocketTxMessage<recording.UpdateRecording> {
    static type: string = 'update-recording';
    proto: recording.UpdateRecording;
    protoClass = recording.UpdateRecording;
    

    constructor(proto: recording.UpdateRecording) {
        super(TxUpdateRecording.type, true);
        this.proto = proto;
    }

    static create(properties: recording.IUpdateRecording = {}) {
        return new TxUpdateRecording(recording.UpdateRecording.create(properties));
    }
}


export class TxListRecordings extends SocketTxMessage<recordings.ListRecordings> {
    static type: string = 'list-recordings';
    proto: recordings.ListRecordings;
    protoClass = recordings.ListRecordings;
    

    constructor(proto: recordings.ListRecordings) {
        super(TxListRecordings.type, true);
        this.proto = proto;
    }

    static create(properties: recordings.IListRecordings = {}) {
        return new TxListRecordings(recordings.ListRecordings.create(properties));
    }
}


export class RxListRecordingsResponse extends SocketRxMessage<recordings.ListRecordingsResponse> {
    static type: string = 'list-recordings-response';
    proto = recordings.ListRecordingsResponse.create({});
    protoClass = recordings.ListRecordingsResponse;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxListRecordingsResponse.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxListRecordingsResponse(message);
    };
}


export class TxDeleteFile extends SocketTxMessage<sfiles.DeleteFile> {
    static type: string = 'delete-file';
    proto: sfiles.DeleteFile;
    protoClass = sfiles.DeleteFile;
    

    constructor(proto: sfiles.DeleteFile) {
        super(TxDeleteFile.type, true);
        this.proto = proto;
    }

    static create(properties: sfiles.IDeleteFile = {}) {
        return new TxDeleteFile(sfiles.DeleteFile.create(properties));
    }
}


export class RxUploadDone extends SocketRxMessage<sfiles.UploadDone> {
    static type: string = 'upload-done';
    proto = sfiles.UploadDone.create({});
    protoClass = sfiles.UploadDone;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxUploadDone.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxUploadDone(message);
    };
}


export class TxUploadEnd extends SocketTxMessage<sfiles.UploadEnd> {
    static type: string = 'upload-end';
    proto: sfiles.UploadEnd;
    protoClass = sfiles.UploadEnd;
    

    constructor(proto: sfiles.UploadEnd) {
        super(TxUploadEnd.type, true);
        this.proto = proto;
    }

    static create(properties: sfiles.IUploadEnd = {}) {
        return new TxUploadEnd(sfiles.UploadEnd.create(properties));
    }
}


export class RxUploadProgress extends SocketRxMessage<sfiles.UploadProgress> {
    static type: string = 'upload-progress';
    proto = sfiles.UploadProgress.create({});
    protoClass = sfiles.UploadProgress;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxUploadProgress.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxUploadProgress(message);
    };
}


export class TxUploadStart extends SocketTxMessage<sfiles.UploadStart> {
    static type: string = 'upload-start';
    proto: sfiles.UploadStart;
    protoClass = sfiles.UploadStart;
    

    constructor(proto: sfiles.UploadStart) {
        super(TxUploadStart.type, true);
        this.proto = proto;
    }

    static create(properties: sfiles.IUploadStart = {}) {
        return new TxUploadStart(sfiles.UploadStart.create(properties));
    }
}


export class RxUploadStartSlot extends SocketRxMessage<sfiles.UploadStartSlot> {
    static type: string = 'upload-start';
    proto = sfiles.UploadStartSlot.create({});
    protoClass = sfiles.UploadStartSlot;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxUploadStartSlot.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxUploadStartSlot(message);
    };
}


export class RxAck extends SocketRxMessage<socket_api.Ack> {
    static type: string = 'ack';
    proto = socket_api.Ack.create({});
    protoClass = socket_api.Ack;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxAck.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxAck(message);
    };
}


export class RxAsyncProgress extends SocketRxMessage<socket_api.AsyncProgress> {
    static type: string = 'async-progress';
    proto = socket_api.AsyncProgress.create({});
    protoClass = socket_api.AsyncProgress;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxAsyncProgress.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxAsyncProgress(message);
    };
}


export class RxIlolAck extends SocketRxMessage<socket_api.IlolAck> {
    static type: string = 'ilol|ack';
    proto = socket_api.IlolAck.create({});
    protoClass = socket_api.IlolAck;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxIlolAck.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxIlolAck(message);
    };
}


export class RxIlolError extends SocketRxMessage<socket_api.IlolError> {
    static type: string = 'ilol|error';
    proto = socket_api.IlolError.create({});
    protoClass = socket_api.IlolError;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxIlolError.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxIlolError(message);
    };
}


export class RxUpgradeApiVersion extends SocketRxMessage<socket_api.UpgradeApiVersion> {
    static type: string = 'upgrade-api-version';
    proto = socket_api.UpgradeApiVersion.create({});
    protoClass = socket_api.UpgradeApiVersion;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxUpgradeApiVersion.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxUpgradeApiVersion(message);
    };
}


export class TxDeleteUFile extends SocketTxMessage<uploader.DeleteUFile> {
    static type: string = 'delete-ufile';
    proto: uploader.DeleteUFile;
    protoClass = uploader.DeleteUFile;
    

    constructor(proto: uploader.DeleteUFile) {
        super(TxDeleteUFile.type, true);
        this.proto = proto;
    }

    static create(properties: uploader.IDeleteUFile = {}) {
        return new TxDeleteUFile(uploader.DeleteUFile.create(properties));
    }
}


export class RxUploadSlot extends SocketRxMessage<uploader.UploadSlot> {
    static type: string = 'upload-slot';
    proto = uploader.UploadSlot.create({});
    protoClass = uploader.UploadSlot;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxUploadSlot.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxUploadSlot(message);
    };
}


export class RxUploadTask extends SocketRxMessage<uploader.UploadTask> {
    static type: string = 'upload-task';
    proto = uploader.UploadTask.create({});
    protoClass = uploader.UploadTask;
    

    constructor(message: SocketRxMessageData | null = null) {
        super(RxUploadTask.type, message);
        if (message !== null) {
            this.proto = this.protoClass.fromObject(message.body);
        }
    }

    fromMessage(message: SocketRxMessageData) {
        return new RxUploadTask(message);
    };
}


export class TxUploadUFile extends SocketTxMessage<uploader.UploadUFile> {
    static type: string = 'upload-ufile';
    proto: uploader.UploadUFile;
    protoClass = uploader.UploadUFile;
    

    constructor(proto: uploader.UploadUFile) {
        super(TxUploadUFile.type, true);
        this.proto = proto;
    }

    static create(properties: uploader.IUploadUFile = {}) {
        return new TxUploadUFile(uploader.UploadUFile.create(properties));
    }
}


        export const rxMessages: SocketRxMessage<any>[] = [
            new RxLoginError(),
    new RxLoginToken(),
    new RxRefreshTokenInvalid(),
    new RxTokenInvalid(),
    new RxGetLessonResponse(),
    new RxCreateChapterResponse(),
    new RxCreateContentBlockResponse(),
    new RxCreateLessonResponse(),
    new RxListLessonsResponse(),
    new RxListPublishedAnnotationsResponse(),
    new RxUpdateChapterResponse(),
    new RxUpdateContentBlockResponse(),
    new RxCreateRecordingResponse(),
    new RxGetRecordingResponse(),
    new RxSaveRecordingAnnotationResponse(),
    new RxListRecordingsResponse(),
    new RxUploadDone(),
    new RxUploadProgress(),
    new RxUploadStartSlot(),
    new RxAck(),
    new RxAsyncProgress(),
    new RxIlolAck(),
    new RxIlolError(),
    new RxUpgradeApiVersion(),
    new RxUploadSlot(),
    new RxUploadTask()
        ];
}